import React from "react";
import Sigil from "./Sigil";

const PROVERBS = [
  { k: "qo'mey poSmoH Hol", es: "El idioma abre mundos." },
  { k: "Heghlu'meH QaQ jajvam", es: "Hoy es un buen día para morir." },
  { k: "Hov ghajbe' bIQ'a'", es: "El océano no tiene estrellas — el código sí." },
  { k: "batlh bIHeghjaj", es: "Que mueras con honor." },
  { k: "yIn ej tlhutlh", es: "Vive y bebe." },
];

const AboutLore = () => {
  return (
    <section
      id="lore"
      data-testid="lore-section"
      className="relative bg-[#050505] py-24 md:py-32 px-6 md:px-12 overflow-hidden border-b border-[#2A0A0A]"
    >
      {/* Decorative side bar */}
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-transparent via-[#8A0303] to-transparent opacity-50" />

      <div className="max-w-6xl mx-auto grid lg:grid-cols-12 gap-12 items-start">
        {/* LEFT — Code of Honor (terminal) */}
        <div className="lg:col-span-7">
          <div className="flex items-center gap-3 mb-4">
            <div className="bar-bronze" />
            <span className="font-mono-k text-[11px] uppercase tracking-[0.4em] text-[#C59B27]">
              código de honor&nbsp;//&nbsp;batlh&nbsp;chut
            </span>
          </div>
          <h2 className="font-display font-black uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.95] text-[#EAEAEA] mb-8" data-testid="lore-title">
            No&nbsp;codificamos<br />
            <span className="text-[#FF2A2A]">conquistamos.</span>
          </h2>

          {/* Terminal block */}
          <div
            data-testid="lore-terminal"
            className="border border-[#2A0A0A] bg-black/70 backdrop-blur-sm relative"
            style={{
              clipPath: "polygon(0 0, calc(100% - 24px) 0, 100% 24px, 100% 100%, 24px 100%, 0 calc(100% - 24px))",
            }}
          >
            {/* Terminal header */}
            <div className="flex items-center justify-between px-5 py-2 border-b border-[#2A0A0A] bg-gradient-to-r from-[#100000] to-transparent">
              <div className="flex items-center gap-2">
                <span className="h-2 w-2 rounded-full bg-[#FF2A2A]" />
                <span className="h-2 w-2 rounded-full bg-[#C59B27]" />
                <span className="h-2 w-2 rounded-full bg-[#3a0000]" />
              </div>
              <span className="font-mono-k text-[10px] uppercase tracking-[0.3em] text-[#555]">
                qonoS://bicio · ~/honor.log
              </span>
            </div>

            {/* Terminal body */}
            <div className="p-6 md:p-8 font-mono-k text-sm space-y-3 leading-relaxed">
              <div><span className="text-[#C59B27]">$</span> <span className="text-[#FF6A6A]">cat</span> <span className="text-[#A0A0A0]">batlh.chut</span></div>
              <div className="text-[#EAEAEA]">
                <span className="text-[#C59B27]">▸</span> El honor se compila en producción.
              </div>
              <div className="text-[#EAEAEA]">
                <span className="text-[#C59B27]">▸</span> Un guerrero no pide perdón al CTO.
              </div>
              <div className="text-[#EAEAEA]">
                <span className="text-[#C59B27]">▸</span> Si la build cae, alguien <em className="not-italic text-[#FF6A6A]">cae</em> con ella.
              </div>
              <div className="text-[#EAEAEA]">
                <span className="text-[#C59B27]">▸</span> No existen los hotfixes — sólo decisiones.
              </div>
              <div className="pt-3 text-[#555] text-xs">— firmado, <span className="text-[#E6B836]">Bicio</span>, capitán del IKS qapla.uk</div>
              <div className="text-[#FF2A2A] animate-pulse">$ <span className="bg-[#FF2A2A]/40 inline-block w-2 h-4 align-middle" /></div>
            </div>
          </div>
        </div>

        {/* RIGHT — Sigil + proverbs */}
        <div className="lg:col-span-5 space-y-8">
          <div className="flex flex-col items-center text-center p-8 border border-[#2A0A0A] bg-gradient-to-b from-[#0e0303] to-transparent relative" data-testid="lore-sigil-block">
            <Sigil size={140} />
            <div className="mt-6 font-display text-2xl text-[#E6B836] tracking-widest">CASA · BICIO</div>
            <div className="mt-1 font-mono-k text-[10px] uppercase tracking-[0.3em] text-[#A0A0A0]">
              tuq · bicio · de la casa digital
            </div>
            <div className="mt-4 font-rune text-[#FF6A6A] text-sm tracking-[0.4em] glitch-soft">
              tlhIngan&nbsp;maH
            </div>
          </div>

          <div className="space-y-3" data-testid="lore-proverbs">
            <div className="font-mono-k text-[10px] uppercase tracking-[0.4em] text-[#C59B27] mb-2">
              proverbios&nbsp;//&nbsp;mu'mey&nbsp;tlhIngan
            </div>
            {PROVERBS.map((p, i) => (
              <div
                key={i}
                className="border-l-2 border-[#8A0303] pl-4 py-2 hover:border-[#E6B836] transition-colors group"
              >
                <div className="font-rune text-[#EAEAEA] text-sm md:text-base tracking-[0.25em] group-hover:text-[#FF6A6A] transition-colors">
                  {p.k}
                </div>
                <div className="font-mono-k text-[#A0A0A0] text-xs italic mt-1">
                  — {p.es}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutLore;
